import { render } from "./VehicleWithdrawalDeleteModal.vue?vue&type=template&id=ab4a1fde"
import script from "./VehicleWithdrawalDeleteModal.vue?vue&type=script&lang=ts"
export * from "./VehicleWithdrawalDeleteModal.vue?vue&type=script&lang=ts"
script.render = render

export default script
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QCardActions,QBtn});
